import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopDermatologist = dynamic(() => import('../../components/spa-salon/dermatologist/DesktopDermatologist'), {
  loading: () => <Loading />,
});
const MobileDermatologist = dynamic(() => import('../../components/spa-salon/dermatologist/MobileDermatologist'), {
  loading: () => <Loading />,
});

const dermatologistPOSBillingSoftware = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Skin Clinic Billing & Management Software - Get a Free Demo</title>
        <link rel="canonical" href="https://queuebuster.co/spa-and-salon/dermatology-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/spa-and-salon/dermatology-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Discover comprehensive Skin Clinic Billing & Management Software by QueueBuster POS. Streamline operations for dermatology, Botox, and Trichology." />
        <meta property="og:title" content="Skin Clinic Billing & Management Software in India - Get Started With a Free Trial" />
        <meta property="og:description" content="Discover comprehensive Skin Clinic Billing & Management Software by QueueBuster POS. Streamline operations for dermatology, Botox, and trichology. Request your free demo now!" />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/derma.jpg" />
        <meta property="og:url" content="https://queuebuster.co/spa-and-salon/dermatology-pos-billing-software" />
      </Head>
         <SchemaTags page="dermatology-pos-billing-software" />
      {
        mobileView ? <MobileDermatologist /> : <DesktopDermatologist />
      }
    </>
  )
}

export default dermatologistPOSBillingSoftware